export default {
  priv: 'pr_manage',
  overviewTitle: 'Klanten',
  detailTitle: 'Klant',
  deleteTitle: 'deze klant',
  url: '/manage/customers',
  apiUrl: '/customers/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'manage/customers',
  defaultPerPage: 100,
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'text'
  },
  advancedSearchFields: [
    {text: 'Actief', value: 'is_active', type: 'boolean'}
  ],
  newRecord: {
    country_id: 56,
    is_active: true
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Naam', value: 'name', link: '/manage/customers/{id}', width: '10%'},
    {text: 'Adres', value: 'street', width: '5%'},
    {text: 'Woonplaats', value: 'city', width: '5%'},
    {text: 'BTW nr', value: 'vatnr', width: '10%'},
    {text: 'Email', value: 'email', width: '10%'},
    {text: 'Email CC', value: 'email_cc', width: '10%'},
    {text: 'Email Bon', value: 'email_transportvoucher', width: '10%'},
    {text: 'Bon Opdrachtgever', value: 'is_transportvoucher_ordering_customer', type: 'boolean', width: '2%'},
    {text: 'CMR Bijvoegen', value: 'is_email_cmr_attach', type: 'boolean', width: '2%'},
    {text: 'CMR Samenvoegen', value: 'is_email_cmr_merge', type: 'boolean', width: '2%'},
    {text: 'Actief', value: 'is_active', type: 'boolean', width: '2%'}
  ]
};
